<template>
    <div class="flex items-center gap-2">
        <button
            v-for="item in types"
            :key="item.id"
            type="button"
            class="py-2 px-3 border rounded-lg"
            :class="{
                'bg-blue-400 text-white border-blue-400': +activeType === +item.id,
                'bg-gray-400 border-gray-400': +activeType !== item.id,
            }"
            :disabled="+activeType === item.id"
            @click="() => handleCruiseTypeClick(item.id)"
        >
            {{ item.title }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'CruiseTypeChoose',
    props: {
        types: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: false,
        },
    },
    emits: ['on-click'],
    computed: {
        activeType() {
            return this.$route.query.type;
        },
    },
    methods: {
        handleCruiseTypeClick(itemId) {
            this.$router.push({ query: { ...this.$route.query, type: itemId } });
            this.$emit('on-click', itemId);
        },
    },
};
</script>

<style scoped lang="scss"></style>
